import React, { useState, useEffect, useRef } from "react";
import { useLanguageContext } from "../../Context/LanguageContext";

export default function MultiSelectCheckbox({
  options,
  selectedValues,
  onChange,
  name,
  disabled,
}) {
  const { localization } = useLanguageContext();
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  const handleSelect = (value) => {
    const newSelectedValues = selectedValues.includes(value)
      ? selectedValues.filter((v) => v !== value)
      : [...selectedValues, value];

    const event = {
      preventDefault: () => {},
      target: {
        name: name,
        value: newSelectedValues,
      },
    };
    onChange(event);
  };

  const handleSelectAll = () => {
    const allValues = options.map((opt) => opt.value);
    const newSelectedValues =
      selectedValues.length === allValues.length ? [] : allValues;
    const event = {
      preventDefault: () => {},
      target: {
        name: name,
        value: newSelectedValues,
      },
    };
    onChange(event);
  };

  const getDisplayText = () => {
    if (selectedValues.length === 0) {
      return localization.select || "Select...";
    }
    if (selectedValues.length === 1) {
      const selectedOption = options.find(
        (opt) => opt.value === selectedValues[0]
      );
      return selectedOption ? selectedOption.label : "";
    }
    return `${selectedValues.length} ${
      localization.itemsSelected || "items selected"
    }`;
  };

  return (
    <div className="dropdown w-100" ref={wrapperRef}>
      <button
        className="btn btn-light dropdown-toggle w-100 text-left multiselect-btn"
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        disabled={disabled}
      >
        {getDisplayText()}
      </button>
      {isOpen && (
        <div
          className="dropdown-menu show w-100"
          style={{ maxHeight: "200px", overflowY: "auto" }}
        >
          {options.length > 0 && (
            <div className="dropdown-item">
              <input
                type="checkbox"
                id={`chk-${name}-select-all`}
                checked={selectedValues.length === options.length}
                onChange={handleSelectAll}
                style={{ marginRight: "10px" }}
              />
              <label
                htmlFor={`chk-${name}-select-all`}
                className="mb-0 font-weight-bold"
              >
                {localization.selectAll || "Select All"}
              </label>
            </div>
          )}
          {options.map((option) => (
            <div key={option.value} className="dropdown-item">
              <input
                type="checkbox"
                id={`chk-${name}-${option.value}`}
                checked={selectedValues.includes(option.value)}
                onChange={() => handleSelect(option.value)}
                style={{ marginRight: "10px" }}
              />
              <label htmlFor={`chk-${name}-${option.value}`} className="mb-0">
                {option.label}
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
